export const SEARCH_QUERY_PARAM = 'q';
export const MIN_COUNT_CHARACTERS_FOR_SEARCH = 2;
